import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "",
    },
  },
  scales: {
    x: {
      title: {
        display: false,
        text: "Month",
      },
      stacked: true,
    },
    y: {
      title: {
        display: false,
        text: "Value",
      },
      min: 0,
      max: 6000,
      ticks: {
        // forces step size to be 50 units
        stepSize: 6000,
      },
    },
  },
};

const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "Novemeber",
  "December",
  "January",
  "February",
];

export const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [
        3000, 2000, 4000, 5000, 6000, 2000, 3300, 1000, 4500, 2100, 5800, 4800,
      ],
      backgroundColor: "grey",
      borderWidth: 1,
      borderRadius: 100,
      borderSkipped: false,
      base: 0,
      barThickness: 18,
    },
    // {
    //   label: 'Dataset 2',
    //   data: [2000],
    //   backgroundColor: "green",
    //   borderWidth:1,
    //   borderRadius : 100,
    //   borderSkipped:false,
    //   base : 0
    // },
  ],
};

export default function BarChartCylinder() {
  return <Bar options={options} data={data} />;
}

/*
Required Data format :
response = > {
  //Array String type format
  time : ['Jan', 'Feb', ......] , 
  // Array Number type format
  values : [1000, 2000, 3000, .....]

}
*/
